module.exports = __webpack_public_path__ + "static/astronaut-22d234ebaa094c5326d6b77bf73cdc20.png";